import React from 'react'

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Divider,
  Typography,
  Button,
} from '@material-ui/core'

import * as service from 'service'
import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'

const DialogChangeStatus = ({
  active,
  integrationId,
  open,
  setOpen = () => {},
  onEvent = () => {},
}) => {
  const snackbar = useSnackbar()

  const changeStatus = async () => {
    try {
      await service.dponet.externalPlatformIntegrations.changeStatus({
        integrationId,
      })
      snackbar.open({
        message: active
          ? 'Integração inativada com sucesso!'
          : 'Integração ativada com sucesso!',
        variant: 'success',
      })
      setOpen(false)
      onEvent()
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(
          error.response && error.response.data && error.response.data.error,
        ),
        variant: 'error',
      })
      setOpen(false)
    }
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>
        <Box>
          <Typography variant="h4">
            {active ? 'Inativar' : 'Ativar'} integração
          </Typography>
        </Box>
      </DialogTitle>
      <Divider />
      <Box mb={1}>
        <DialogContent>
          <Typography>
            Tem certeza que deseja {active ? 'inativar' : 'ativar'} esta
            integração?
          </Typography>
        </DialogContent>
      </Box>
      <Divider />
      <DialogActions>
        <Box pl={2} pr={1}>
          <Button
            type="button"
            variant="outlined"
            onClick={() => setOpen(false)}
          >
            Cancelar
          </Button>
        </Box>
        <Button
          variant="contained"
          type="submit"
          color="primary"
          onClick={changeStatus}
        >
          Continuar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogChangeStatus
